interface ProductTitleProps {
  name: string;
  className?: string;
}

export const ProductTitle = ({ name, className = '' }: ProductTitleProps) => {
  return (
    <h3 className={`text-lg font-semibold text-gray-900 line-clamp-2 ${className}`}>
      {name}
    </h3>
  );
};
